<template>
    <div class="body">
        <el-row type="flex" justify="center">
            <el-col style="width: 260px;padding-top: calc(20vh)">
                <div style="line-height: 100px">开能禅管理系统登录</div>
                <el-form :model="loginrule"  :rules="lrule" ref="loginrule" class="demo-ruleForm">
                    <el-form-item prop="account">
                        <el-input size="medium" v-model="loginrule.account" placeholder="请输入管理员账号" prefix-icon="iconfont feike-my"></el-input>
                    </el-form-item>
                    <el-form-item prop="pwd">
                        <el-input type="password" v-model="loginrule.pwd" size="medium" placeholder="请输入密码" prefix-icon="iconfont feike-lock"></el-input>
                    </el-form-item>
                    <el-form-item style="text-align: left">
                        <el-button size="medium" style="width: 100%;" type="primary" @click="submitForm('loginrule')">登录</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
    </div>
</template>

<script>
    export default {
        name: "Login",
        mounted() {
            this.getstart()
        },
        data() {
            return {
                dataa: [],
                fullscreenLoading: false,
                labelPosition: 'right',
                formLabelAlign: {
                    name: '',
                    region: '',
                    type: ''
                },
                loginrule: {
                    pwd: '',
                    account: ''
                },
                lrule: {
                    account :[
                        { required: true, message: '请输入管理员账号', trigger: 'blur' }
                    ],
                    pwd :[
                        { required: true, message: '请输入密码', trigger: 'blur' },
                    ]
                },
            }
        },
        methods: {
            getstart() {
            },
            onSubmit() {
                console.log('submit!');
            },
            qingchu() {
                var fb={
                    name: '',
                    region: '',
                    type: ''
                };
                this.formLabelAlign=fb
                console.log(this.formLabelAlign);
            },
            gohref(name){
                this.$router.push({ name: name, params: { userId: 123 }})
            },
            submitForm(formName) {
                let thi = this
                thi.$refs[formName].validate((valid) => {
                    if (valid) {
                        thi.fullscreenLoading = true
                        thi.$http.post(global.posturl.host+global.posturl.login,
                            thi.$refs[formName].model
                        ).then(function (response) {
                            console.log(response.data,'登录数据')
                            var qcode = response.data.code
                            var qmsg = response.data.msg
                            var qdata = response.data.data
                            thi.fullscreenLoading = false
                            if(qcode==200){
                                thi.$http.defaults.headers.common['fs-token'] = qdata.jwt;
                                // thi.$http.defaults.headers.common['area_id'] = qdata.user_id;
                                thi.$http.defaults.timeout = 30000;
                                var router=  thi.getOneRoter(qdata.permission.split(','))
                              thi.aa= router
                              console.log(router,'iii')
                              if(router=='index'){
                                thi.aa = 'orderListH5'
                              }
                                thi.$store.commit('login',qdata)
                                thi.gohref(thi.aa)
                            }else{
                                thi.$message({
                                    message: qmsg,
                                    type: 'error',
                                    duration: 5000
                                });
                            }
                        }).catch(function (error) {
                            console.log(error)
                          console.log('123')
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
          getOneRoter(data){
              console.log(data,'data')
              console.log(data[0],'data')
            if(data[0]==''){
              this.type=data[1]
            }else{
              this.type=data[0]
            }
           var type1= this.type
            switch (type1) {
              case '1':
                return "user";
              case '2':
                return "headImg";
              case '3':
                return "videotheme";
              case '4':
                return "orderListH5";
              case '5':
                return "finance";
              case '6':
                return "partner";

              default:
                return "index";
            }

          }


        }
    }
</script>

<style scoped>
    .body{
    }
</style>



// WEBPACK FOOTER //
// src/page/Login.vue